import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { TranslateService } from "../../services/translate/translate.service";

@Component({
  selector: "mg-modal-delete",
  templateUrl: "./modal-delete.component.html",
  styleUrls: ["./modal-delete.component.scss"],
})
export class ModalDeleteComponent implements OnInit, OnDestroy {
  subscriptionTranslate!: Subscription;
  dataTranslateUserGroups!: any;
  constructor(
    public dialogRef: MatDialogRef<ModalDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string },
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getTranslate();
  }

  close(resp: boolean) {
    this.dialogRef.close({ resp });
  }

  getTranslate() {
    this.subscriptionTranslate = this.translate.init("core").subscribe((data) => {
      this.dataTranslateUserGroups = data.userGroups.modalDelete;
    });
  }

  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }
}
